import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideBar',{attrs:{"bar_name":"Report Email","user":_vm.user}}),_c(VMain,[_c(VContainer,{attrs:{"fluid":""}},[_c('ReportEmailComp',{attrs:{"user":_vm.user}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }